var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-box"},[_c('nav',{staticClass:"tab"},_vm._l((_vm.tabMap),function(tab,key,index){return _c('aside',{key:index,staticClass:"tab-item",class:{ active: _vm.activeTab === key },on:{"click":function($event){return _vm.changeTab(key)}}},[_c('h3',[_vm._v(" "+_vm._s(tab)+" ")]),_c('hr')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }